<template>
  <section v-if="!inFrame" :class="classObj" class="app-wrapper">
    <Sidebar class="sidebar-container" @panelChange="panelChange" />
    <article class="main-container">
      <div :class="{ 'fixed-header': false }">
        <Navbar v-if="false" />
      </div>
      <AppMain />
    </article>
    <!-- 用户中心面板 -->
    <UserCenter
      ref="panelUserCenter"
      :visible="visible.UserCenter"
      @close="visible.UserCenter = false"
    />
    <SwitchAccount
      :visible="visible.SwitchAccount"
      @close="visible.SwitchAccount = false"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserCenter from "@/layout/components/userCenter";
import SwitchAccount from "@/layout/components/userCenter/switchAccount";
// import ThemePicker from "@/layout/components/themePicker";
// import PanelSetting from "@/layout/components/panelSetting";
import { Sidebar, Navbar, AppMain } from "./components";
import { menuParameterDisp, sentBuryPointInfo } from "@/utils/buryPoint";
import { PermissionFilterBl } from "@/utils/filters";

export default {
  components: {
    Sidebar,
    Navbar,
    AppMain,
    UserCenter,
    SwitchAccount
    // ThemePicker,
    // PanelSetting
  },
  data() {
    return {
      visible: {
        UserCenter: false,
        SwitchAccount: false
      }
    };
  },
  computed: {
    ...mapGetters(["sidebar", "microAppRoutes"]),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation
      };
    },
    inFrame() {
      return parent !== window;
    }
  },
  watch: {
    "$route.path": {
      handler(newVal) {
        this.$nextTick(() => {
          const domSidebar = document.querySelector(".sidebar-container");
          const domMain = document.querySelector(".main-container");
          const iframe1 = document.getElementById("iframe1");
          if (domSidebar && domMain && iframe1) {
            //特殊处理菜单侧边栏收齐icon图标
            if (newVal === "/report/onlineReport/topicReport") {
              domSidebar.style.zIndex = "10000";
              domMain.style.zIndex = "9999";
              iframe1.style.width = "100%";
            } else {
              domSidebar.style.zIndex = " ";
              domMain.style.zIndex = " ";
            }
          }
        });
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.onBury();
  },
  methods: {
    panelChange(value) {
      Object.keys(this.visible).forEach(key => {
        this.visible[key] = false;
      });
      this.visible[value] = true;
    },
    onClose(value) {
      this.visible[value] = false;
    },
    onBury() {
      const parameter = menuParameterDisp(window.location.pathname);
      // console.log(parameter);
      if (parameter) {
        const param = {
          ...parameter,
          eventName: "点击菜单",
          eventCode: "click"
        };
        sentBuryPointInfo({
          ...param,
          eventContext: {
            url: "/dashboard"
          },
          eventName: "点击产品"
        });
        sentBuryPointInfo(param);
      }
      this.asideRightBl = PermissionFilterBl(
        this.$router.history._startLocation
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1000;
  background: $bg;
}
</style>
